export default __webpack_public_path__ + "static/media/joystick.50cb9268.svg";